export const resourceTag = 'resource:';
